import { combineReducers } from 'redux';
import User from 'store/stores/User/reducers';

const reducers = combineReducers({ User });

export default reducers;
